/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type IssueLoginLinkUrlFromCsvInput = {
  csv: any;
};

export type IssueLoginLinkUrlFromCsvMutationVariables = Exact<{
  input: Types.IssueLoginLinkUrlFromCsvInput;
}>;


export type IssueLoginLinkUrlFromCsvMutation = { issueLoginLinkURLFromCSV:
    | { __typename: 'IssueLoginLinkURLFromCSVErrorProviderNotFoundPayload' }
    | { __typename: 'IssueLoginLinkURLFromCSVSuccessPayload', csv: any }
   };


export const IssueLoginLinkUrlFromCsvDocument = gql`
    mutation issueLoginLinkURLFromCSV($input: IssueLoginLinkURLFromCSVInput!) {
  issueLoginLinkURLFromCSV(input: $input) {
    __typename
    ... on IssueLoginLinkURLFromCSVSuccessPayload {
      csv
    }
  }
}
    `;

/**
 * __useIssueLoginLinkUrlFromCsvMutation__
 *
 * To run a mutation, you first call `useIssueLoginLinkUrlFromCsvMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useIssueLoginLinkUrlFromCsvMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useIssueLoginLinkUrlFromCsvMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useIssueLoginLinkUrlFromCsvMutation(options: VueApolloComposable.UseMutationOptions<IssueLoginLinkUrlFromCsvMutation, IssueLoginLinkUrlFromCsvMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<IssueLoginLinkUrlFromCsvMutation, IssueLoginLinkUrlFromCsvMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<IssueLoginLinkUrlFromCsvMutation, IssueLoginLinkUrlFromCsvMutationVariables>(IssueLoginLinkUrlFromCsvDocument, options);
}
export type IssueLoginLinkUrlFromCsvMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<IssueLoginLinkUrlFromCsvMutation, IssueLoginLinkUrlFromCsvMutationVariables>;